import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

function formatEventDate(date: Date): string {
  const datePart = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const timePart = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${datePart} - ${timePart}`;
}

export const EventTimestamp = memo(function EventTimestamp({
  event,
}: {
  event: ConversationTimelineEventResponse;
}) {
  return (
    <Text fontSize="xxs" textColor="tertiary">
      {formatEventDate(event.occurredAt)}
    </Text>
  );
});
